import { Divider, Stack, styled, Typography } from '@mui/material';
import { SidebarHeaderProps } from '@shared/components';

export function RetailExpandedSidebarHeader({ title }: Pick<SidebarHeaderProps, 'title'>) {
  return (
    <Stack mt={4}>
      <SidebarTypography variant="body2" sx={{ marginX: 3 }}>
        {title}
      </SidebarTypography>

      <Divider sx={{ paddingBottom: 3, marginBottom: 1 }} />
    </Stack>
  );
}

export function RetailCollapsedSidebarHeader({ title }: Pick<SidebarHeaderProps, 'title'>) {
  return (
    <Stack alignItems="center">
      <SidebarTypography variant="body2" mt={4}>
        {title}
      </SidebarTypography>
    </Stack>
  );
}

const SidebarTypography = styled(Typography)(({ theme }) => ({
  fontWeight: 500,
  color: theme.vars.palette.text.secondary,
}));
